import {
  BranchStatusEnum,
  FilterableEnrollmentStatus,
  FilterableUserStatus,
  UserStatusEnum,
} from '@/client/courses';
import { TranslationFunctionType } from '../types';

const statusTranslationKeys: Record<FilterableUserStatus, string> = {
  [UserStatusEnum.IN_PROGRESS]: 'course.attempt.status.inProgress',
  [UserStatusEnum.COMPLETED]: 'course.attempt.status.completed',
  [UserStatusEnum.FORCE_COMPLETED]: 'course.attempt.status.forceCompleted',
  [UserStatusEnum.FAILED]: 'course.attempt.status.failed',
  [UserStatusEnum.ENROLLED]: 'course.attempt.status.enrolled',
  [UserStatusEnum.SCHEDULED]: 'course.attempt.status.scheduled',
  [UserStatusEnum.NOT_SCHEDULED]: 'course.attempt.status.notScheduled',
};

const enrollmentReachableStatuses: FilterableEnrollmentStatus[] = [
  UserStatusEnum.IN_PROGRESS,
  UserStatusEnum.COMPLETED,
  UserStatusEnum.FORCE_COMPLETED,
  UserStatusEnum.FAILED,
  UserStatusEnum.ENROLLED,
];

const scheduleOnlyStatuses: Exclude<
  FilterableUserStatus,
  FilterableEnrollmentStatus
>[] = [UserStatusEnum.SCHEDULED, UserStatusEnum.NOT_SCHEDULED];

const toStatusOptions = (
  t: TranslationFunctionType,
  statuses: FilterableUserStatus[],
) =>
  statuses.map((status) => ({
    label: t(statusTranslationKeys[status]),
    value: status,
  }));

export const enrollmentStatusOptions = (t: TranslationFunctionType) =>
  toStatusOptions(t, enrollmentReachableStatuses);

export const userStatusOptions = (t: TranslationFunctionType) =>
  toStatusOptions(t, [...enrollmentReachableStatuses, ...scheduleOnlyStatuses]);

export const branchStatusOptions = (t: TranslationFunctionType) => [
  {
    label: t('course.attempt.status.enrolled'),
    value: BranchStatusEnum.ENROLLED,
  },
  {
    label: t('course.attempt.status.scheduled'),
    value: BranchStatusEnum.SCHEDULED,
  },
  {
    label: t('course.attempt.status.notScheduled'),
    value: BranchStatusEnum.NOT_SCHEDULED,
  },
];
